import { Stack, Typography } from '@mui/material';
import React from 'react';
import { InvoiceNotFound } from '@vy/ui-design-system';

export const DynamicInvoiceViewPageInvoiceNotFound: React.FC = () => {
  return (
    <Stack
      direction="column"
      sx={{
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        gap: "8px",
        bgcolor: "white"
      }}>
      <InvoiceNotFound />
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 600,
          lineHeight: "14px"
        }}>
        Invoice does not exist
      </Typography>
      <Typography variant="body1" sx={{
        color: "text.secondary"
      }}>
        The invoice you’re looking for was not found
      </Typography>
    </Stack>
  );
};
